import React from 'react';
import { Modal } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { RootState } from '../redux/store';
import { clearSessionExpired } from '../redux/auth/authSlice';
import useRedux from '../hooks/useRedux';
import Button from './SojusForm/Button';

const SessionExpiredModal = () => {
    const { dispatch } = useRedux();
    const { t } = useTranslation();
    const sessionExpired = useSelector((state: RootState) => state.auth.sessionExpired);

    const goToLogin = () => {
        dispatch(clearSessionExpired());
        window.location.href = '/account/login';
    };

    return (
        <Modal show={!!sessionExpired} backdrop="static" keyboard={false} centered>
            <Modal.Header>
                <Modal.Title>{t('topbar.authorizationTimeoutInfo.expiredTitle')}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="text-center">
                <i className="far fa-clock fa-2x text-muted mb-3 d-block" />
                <p className="mb-0">{t('topbar.authorizationTimeoutInfo.expiredText')}</p>
            </Modal.Body>
            <Modal.Footer className="justify-content-center">
                <Button
                    type="button"
                    label={t('topbar.authorizationTimeoutInfo.relogin')}
                    level="primary"
                    faIcon="fas fa-sign-in-alt"
                    onClick={goToLogin}
                />
            </Modal.Footer>
        </Modal>
    );
};

export default SessionExpiredModal;
